import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import { Avatar, Box, IconButton, Tooltip, Typography } from "@mui/material";
import { PropTypes } from "prop-types";
import { useTranslation } from "react-i18next";

import { identifiersData, inputData, namesData } from "@/data";
import { StyledFileLink } from "@/styles";
import { getSubstringHandler } from "@/utils";

const FileLink = ({
    deleteAction,
    hasDelete,
    hasDownload,
    hasImage,
    hasJustifyStart,
    id,
    link,
    name,
    otherData,
    rowId,
    startData,
}) => {
    const { t } = useTranslation();

    const { button: buttonId, input: inputId, link: linkId } = identifiersData.ids;

    const { delete: deleteButtonName, download: downloadButtonName } = namesData.buttons;

    const { file: fileInputName } = inputData.names;

    return (
        <Box
            sx={{
                alignItems: "center",
                display: "flex",
                gap: 1,
                justifyContent: "start",
                mt: 1,
            }}
        >
            {startData}
            {hasImage && (
                <Avatar
                    alt={t("imageAlternatives.file")}
                    slotProps={{ img: { loading: "lazy" } }}
                    src={`${import.meta.env.VITE_BACKEND_DOMAIN}${link}`}
                    sx={{ borderRadius: 1 }}
                />
            )}
            <StyledFileLink hasJustifyStart={hasJustifyStart ? +true : +false}>
                {hasDownload ? (
                    <a
                        href={`${import.meta.env.VITE_BACKEND_DOMAIN}${link}`}
                        id={
                            id
                                ? `${id}_${inputId}_${linkId}${rowId ? `_${rowId}` : ""}`
                                : `${fileInputName}_${inputId}_${linkId}${rowId ? `_${rowId}` : ""}`
                        }
                        rel="noreferrer"
                        target="_blank"
                        download
                    >
                        {getSubstringHandler(name, 40)}
                    </a>
                ) : (
                    <Typography variant="caption">{getSubstringHandler(name, 30)}</Typography>
                )}
                {otherData && <Box>{otherData}</Box>}
                <Box
                    sx={{
                        display: "flex",
                    }}
                >
                    {hasDownload && (
                        <Tooltip title={t("actions.download")}>
                            <IconButton
                                id={
                                    id
                                        ? `${id}_${inputId}_${downloadButtonName}_${buttonId}${rowId ? `_${rowId}` : ""}`
                                        : `${fileInputName}_${inputId}_${downloadButtonName}_${buttonId}${rowId ? `_${rowId}` : ""}`
                                }
                            >
                                <a
                                    href={`${import.meta.env.VITE_BACKEND_DOMAIN}${link}`}
                                    rel="noreferrer"
                                    target="_blank"
                                    download
                                >
                                    {}
                                    <DownloadIcon
                                        sx={{
                                            position: "relative",
                                            top: 5,
                                        }}
                                    />
                                </a>
                            </IconButton>
                        </Tooltip>
                    )}
                    {hasDelete && (
                        <Tooltip title={t("actions.delete")}>
                            <IconButton
                                id={
                                    id
                                        ? `${id}_${inputId}_${deleteButtonName}_${buttonId}${rowId ? `_${rowId}` : ""}`
                                        : `${fileInputName}_${inputId}_${deleteButtonName}_${buttonId}${rowId ? `_${rowId}` : ""}`
                                }
                                onClick={deleteAction}
                            >
                                <DeleteForeverOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                    )}
                </Box>
            </StyledFileLink>
        </Box>
    );
};

export default FileLink;

FileLink.propTypes = {
    deleteAction: PropTypes.func,
    hasDelete: PropTypes.bool,
    hasDownload: PropTypes.bool,
    hasImage: PropTypes.bool,
    hasJustifyStart: PropTypes.bool,
    id: PropTypes.string,
    link: PropTypes.string,
    name: PropTypes.string,
    otherData: PropTypes.node,
    rowId: PropTypes.number,
    startData: PropTypes.node,
};
